import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController, ToastController } from 'ionic-angular';
import { AngularFireAuth } from 'angularfire2/auth';
import { FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the PasswordRecoveryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-password-recovery',
  templateUrl: 'password-recovery.html',
})
export class PasswordRecoveryPage {
  public loginForm: any;

  constructor(public afAuth: AngularFireAuth,
    public fb: FormBuilder,
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    public translate: TranslateService) {
    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    this.loginForm = fb.group({
      email: [this.navParams.get('email'), Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])],
    });

  }

  ionViewDidLoad() {
  }

  passwordRecover() {
    if (!this.loginForm.valid) {
      //this.presentAlert('Username password can not be blank')
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-sin-email'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    } else {
      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: this.translate.instant('instant-loading')
      });
      loadingPopup.present();

      this.afAuth.auth.sendPasswordResetEmail(this.loginForm.value.email).then(_ => {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('instant-email-enviado-reinicio-contrasena') + ": " + this.loginForm.value.email,
          duration: 3000,
          position: 'top'
        });
        toast.present();
        loadingPopup.dismiss();
        this.navCtrl.pop();
      }, error => {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('password-recovery-no-email'),
          duration: 3000,
          position: 'top'
        });
        toast.present();
        loadingPopup.dismiss();
      });
    }
  }

  back() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/auth/password-recovery/password-recovery.ts